import { useRef } from 'react'

import { faPaintRoller } from '@fortawesome/pro-light-svg-icons/faPaintRoller'
import Button from '@space-core/components/button'
import Icon from '@space-core/components/icon'

import { useParentInfoStore } from '@space-shell/remotes/preview/store/parentInfo'

import { useTranslation } from 'react-i18next'

import { Container, OptionsModal, Section, Highlight, Line } from './bannerEmptyStateStyles'

const BannerEmptyState = () => {
  const ref = useRef<HTMLElement>(null)

  const {
    handleHideBanner,
    handleGoToBannerMenu,
    hideBanner,
    isEditing,
    showBannerHighlight,
    theme
  } = useParentInfoStore()

  const { t } = useTranslation()

  if (hideBanner) {
    return null
  }

  return (
    <Section ref={ref} className='_d-flex _flex-wrap _h-full _w-full _mb-12' $theme={theme}>
      <Container
        $showBannerHighlight={showBannerHighlight}
        className='_w-full _position-relative _d-flex _align-items-center'>
        <div className='_d-flex _flex-column _w-half _px-8'>
          <Line />
          <Line />
          <Line />
        </div>

        {showBannerHighlight && (
          <Highlight className='_text-white _px-2 _bg-blue _rounded-top _d-flex _align-items-center _justify-content-center'>
            <span className='_test-1'>{t('preview.highlights.banner')}</span>
          </Highlight>
        )}
        {!isEditing && (
          <OptionsModal className='_bg-primary _rounded _px-4 _py-3'>
            <div className='_d-flex _align-items-center _justify-content-center _mb-4'>
              <Icon
                aria-hidden
                icon={faPaintRoller}
                className='_text-gray-900 _mr-4'
                data-test='empty-icon'
              />
              <h2 className='_font-weight-bold _text-gray-900 _text-1 _m-0'>
                {t('preview.banner.empty_state.title')}
              </h2>
            </div>
            <div className='_w-full _d-flex _align-items-center _justify-content-center'>
              <Button className='_text-1 _mr-4' variation='tertiary' onClick={handleHideBanner}>
                {t('preview.banner.empty_state.create_later')}
              </Button>
              <Button className='_text-1' variation='primary' onClick={handleGoToBannerMenu}>
                {t('preview.banner.empty_state.create_banner')}
              </Button>
            </div>
          </OptionsModal>
        )}
      </Container>
    </Section>
  )
}

export default BannerEmptyState
